<ion-item-sliding class="shaded-slider">
  <ion-item-options side="start" *ngIf="type?.key !== 'Consultation' && !isSearching" #noShowOptions>
    <ion-item-option class="deleteClient" color="danger" (click)="handleNoShow(client)">
      <div class="flex align-items-center flex-column">
        <ion-icon name="calendar"></ion-icon>
        <ion-text>No Show</ion-text>
      </div>
    </ion-item-option>
  </ion-item-options>

  <ion-item [detail]="true" class="icon-list" [ngClass]="{'loadThisClient': !requires_invite}" (click)="handleClientClick()">
    <ion-avatar *ngIf="isConsultation">
      <ng-container *ngIf="status == 'Completed'">
        <ion-icon *ngIf="!client.consultation.signed_up && status == 'Completed'" style="font-size:37px;color:red;margin-left:-3px;" name="close-circle"></ion-icon>
        <ion-icon *ngIf="client.consultation.signed_up && status == 'Completed'" style="font-size:37px;color:green;margin-left:-3px;" name="checkmark-circle"></ion-icon>
      </ng-container>
      <ng-container *ngIf="status != 'Completed'">
        <ion-icon style="font-size:37px;color:red;margin-left:-3px;" name="person-circle"></ion-icon>
      </ng-container>
    </ion-avatar>

    <ion-avatar *ngIf="!isConsultation">
      <ion-icon *ngIf="(client.no_show || client.internal_status == 'no_show')" style="font-size:37px;color:red;margin-left:-3px;"
        name="close-circle"></ion-icon>
      <ion-icon *ngIf="(status != 'Completed' && (client.internal_status != 'no_show' && client.no_show == false)) || isSearching" style="font-size:37px;color:red;margin-left:-3px;"
        name="person-circle"></ion-icon>
      <ion-icon *ngIf="status == 'Completed' && (client.internal_status != 'no_show' && client.no_show == false)"
        style="font-size:37px;color:green;margin-left:-3px;" name="checkmark-circle"></ion-icon>
    </ion-avatar>

    <client-row-content
      [type]="type"
      [status]="status"
      [internalStatus]="client.internal_status"
      [noShow]="client.no_show"
      [client]="client"
      [locationName]="locationService.getLocationName(client.location_id)"
      [showDetail]="isSearching"
    ></client-row-content>

    <ion-badge *ngIf="client.has_pending_visit" color="warning" slot="end">Pending Visit</ion-badge>
    <ion-badge *ngIf="client.signed_into_app === false" color="danger" slot="end">Missing App!</ion-badge>

    <ion-icon *ngIf="requires_invite" slot="end" class="ion-text-right" color="primary" name="add-circle-outline"></ion-icon>

    <ion-text *ngIf="!isSearching" class="subtle" slot="end">
      <small>{{ client.time | amUtc | amDateFormat: 'h:mm a' }}</small>
    </ion-text>
  </ion-item>

  <ion-item-options side="end" class="sliding-button">
    <ion-item-option class="deleteClient" color="danger" (click)="selectClientForDeletion(client)">
      <div class="flex align-items-center flex-column">
        <ion-icon name="trash"></ion-icon>
        <ion-text>Delete</ion-text>
      </div>
    </ion-item-option>
  </ion-item-options>
</ion-item-sliding>
